import { MouseEvent, useRef } from 'react';
import { CriteriaV3AnswerBtn, CriteriaV3AnswerImg } from './CriteriaV3Step.style';
import { Criteria } from '../../../models/Criteria';

interface CriteriaV3AnswerButtonProps {
  criteria: Criteria;
  onClick: (criteria: Criteria) => void;
  isSecondary: boolean;
}

export const CriteriaV3AnswerButton = ({ criteria, isSecondary, onClick }: CriteriaV3AnswerButtonProps) => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    if (buttonRef.current) {
      buttonRef.current.focus();
    }
    onClick(criteria);
  };

  return (
    <CriteriaV3AnswerBtn
      id={criteria.id}
      onClick={handleClick}
      className={isSecondary ? 'secondary' : ''}
      onTouchStart={() => handleClick}
      ref={buttonRef}
    >
      {criteria.meta?.iconUrl && <CriteriaV3AnswerImg src={criteria.meta?.iconUrl} />}
      {criteria.label}
    </CriteriaV3AnswerBtn>
  );
};
